var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("pie-chart", {
    staticClass: "chart",
    attrs: {
      titulo: _vm.titulo,
      fonte: _vm.fonte,
      dados: _vm.categoriasCdsSeries,
      "dados-complementares": _vm.categoriasCdsSubSeries,
      "is-get-svg": _vm.isGetSvg,
    },
    on: { svg: (value) => _vm.$emit("svg", value) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }